import { render, staticRenderFns } from "./CourseLessons.vue?vue&type=template&id=9764e61c"
import script from "./CourseLessons.vue?vue&type=script&lang=js"
export * from "./CourseLessons.vue?vue&type=script&lang=js"
import style0 from "./CourseLessons.vue?vue&type=style&index=0&id=9764e61c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/tony.yu/Documents/asd-tmm-client-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../../../Users/tony.yu/Documents/asd-tmm-client-vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
